import { connect } from "react-redux";
import React, { useState } from "react";
import { Button, ModalHeader, ModalBody } from "reactstrap";
import { compose } from "redux";
import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";
import { useFormik } from "formik";
import { addPanchangDay, editPanchangDay } from "services/panchangDayServices";
import {
  VIKRAM_SAMVAT_MONTHS,
  TITHI_NAMES,
  // RITU_NAMES,
  // NAKSHATRA_NAMES,
  // RASHI_NAMES,
} from "helper/constant";
import Select from "react-select";
import DatePicker from "react-datepicker";
// import moment from "moment";

// import CustomTimePicker from '../../../components/common/CustomTimePicker';
import panchangDaySchema from "./validationSchema";
import DatePickerWrapper from "components/common/DatePickerWrapper";
const { success, error } = NavigationActions;

const AddEditEvent = ({ isEdit, editData, onClose, token, toggleRefresh }) => {
  const [loading, setLoading] = useState(false);
  const tithiOptions = Object.keys(TITHI_NAMES).map((key) => ({
    value: key,
    label: `${key} - ${TITHI_NAMES[key]}`,
  }));
  const monthOptions = VIKRAM_SAMVAT_MONTHS.map((val) => ({
    value: val,
    label: val,
  }));
 
  console.log("editData",editData)

  const pakshaOptions = [
    {
      label: "Shukla",
      value: "Shukla",
    },
    {
      label: "Krishna",
      value: "Krishna",
    },
  ];
  // console.log("moment",moment("06:00 AM", "hh:mm A"))
  // console.log("dayjs",moment("06:00 AM", "hh:mm A"))
  const formik = useFormik({
    initialValues: isEdit
      ? {
          ...editData,
          tithi: editData?.tithi?.split("-").map((item) => {
            return { value: item, label: `${item} - ${TITHI_NAMES[item]}` };
          }),
          gregorianDate: new Date(editData.gregorianDate),
        }
      : {
          gregorianDate: new Date(),
          // vikramSamvatYear: 2081,
          vikramSamvatMonth: "",
          tithi: "",
          paksha: "",
          event: {
            english: "",
            gujarati: "",
            hindi: "",
          },
        },
    validationSchema: panchangDaySchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const tithiNo =
          values.tithi?.length > 1
            ? TITHI_NAMES[values.tithi[0].value] +
              "-" +
              TITHI_NAMES[values.tithi[1].value]
            : TITHI_NAMES[values.tithi[0].value];
        const payload = {
          ...values,
          gregorianDate: values.gregorianDate.toISOString(),
          tithi: values?.tithi?.map(item=>item.value).join("-"),
          tithiNo,
        };

        // convert payload to formData
        // const formData = new FormData();
        // for (const key in payload) {
        //   if (payload.hasOwnProperty(key)) {
        //     if (key === "event") {
        //       // console.log("event", payload[key]);
        //       formData.append(key, JSON.stringify(payload[key]));
        //     } else {
        //       formData.append(key, payload[key]);
        //     }
        //   }
        // }

        console.log("Submitting payload:", payload);

        const res = isEdit
          ? await editPanchangDay(token, values?._id, payload)
          : await addPanchangDay(token, payload);
        if (res?.success) {
          success(res?.message);
          onClose();
          toggleRefresh(true);
        } else {
          error(res?.message);
        }
      } catch (error) {
        error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const Error = (props) => {
    const field1 = props.field;
    if ((formik.errors[field1] && formik.touched[field1]) || formik.submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {formik.errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
  } = formik;

  console.log(formik?.errors);
  
  return (
    <>
      <ModalHeader toggle={() => onClose()}>
        {isEdit ? "Edit" : "Add"} Event
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {/* <div className="form-group">
            <label>Image</label>
            <br />

            <input
              type="file"
              id="upload"
              className="form-control react-form-input"
              accept=".jpg,.png,.jpeg,.svg"
              onChange={(e) => {
                if (e.target.files[0]) {
                  formik.setFieldValue("image", e.target.files[0]);
                } else {
                  formik.setFieldValue("image", "");
                }
              }}
              onBlur={handleBlur}
            />
            {values?.image && (
              <>
                <br />
                <img
                  src={
                    values.image instanceof Blob
                      ? URL.createObjectURL(values.image)
                      : `${process.env.REACT_APP_UPLOAD_DIR}${values?.image}`
                  }
                  className="profile-img"
                  alt="no"
                  width={200}
                />
                <br />
              </>
            )}
            <Error field="image" />
          </div> */}
            <div className="row form-group">
              <div className="form-group col-12 w-100 col-sm-6">
                <label>
                  Date <span className="red">*</span>
                </label>
                <DatePickerWrapper>
                  <DatePicker
                    peekPriviousMonth
                    showMonthDropdown
                    showYearDropdown
                    name="gregorianDate"
                    id="gregorianDate"
                    selected={values.gregorianDate}
                    dateFormat="yyyy/MM/dd"
                    className="form-control react-form-input w-100"
                    value={values.gregorianDate}
                    onChange={(date) => {
                      formik.setFieldValue("gregorianDate", date);
                    }}
                    onBlur={handleBlur}
                  />
                </DatePickerWrapper>
                <Error field="gregorianDate" />
              </div>

              <div className="form-group col-12 col-sm-6">
                <label>
                  Vikram Samvat Month<span className="red">*</span>
                </label>
                <Select
                  value={monthOptions.find(
                    (item) => item.value === values.vikramSamvatMonth
                  )}
                  name="vikramSamvatMonth"
                  options={monthOptions}
                  className="basic-multi-select w-100"
                  classNamePrefix="select"
                  onChange={(selected) => {
                    formik.setFieldValue("vikramSamvatMonth", selected.value);
                  }}
                />

                <Error field="vikramSamvatMonth" />
              </div>
            </div>

          <div className="form-group d-flex mb-0">
            <div className="form-group mr-2 w-50">
              <label>
                Tithi <span className="red">*</span>
              </label>
              <Select
                isMulti={true}
                value={values.tithi}
                name="tithi"
                options={tithiOptions}
                className="basic-multi-select w-100"
                classNamePrefix="select"
                onChange={(selected) => {
                  formik.setFieldValue("tithi", selected);
                }}
                handleBlur={handleBlur}
              />
              <Error field="tithi" />
            </div>
            <div className="ml-2 form-group w-50">
              <label>
                Paksha <span className="red">*</span>
              </label>
              <Select
                isDisabled={
                  values.tithi === "Purnima" || values.tithi === "Amavasya"
                }
                value={pakshaOptions.find((i) => i.value === values.paksha)}
                name="paksha"
                options={pakshaOptions}
                className="basic-multi-select w-100"
                classNamePrefix="select"
                onChange={(selected) => {
                  formik.setFieldValue("paksha", selected.value);
                }}
              />
              <Error field="paksha" />
            </div>
          </div>

          <div className="form-group">
            <label>
              Swaminarayan Samvat English
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="swaminarayanSamvat.english"
              onChange={handleChange}
              value={values?.swaminarayanSamvat?.english}
              onBlur={handleBlur}
              placeholder="Swaminarayan Samvat Details"
            />
            {/* <Error field="swaminarayanSamvat.english" /> */}
            {((formik.errors?.swaminarayanSamvat?.english &&
              formik.touched?.swaminarayanSamvat?.english) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.swaminarayanSamvat?.english}
              </span>
            )}
          </div>

          <div className="form-group">
            <label>
              Swaminarayan Samvat Gujarati
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="swaminarayanSamvat.gujarati"
              onChange={handleChange}
              value={values?.swaminarayanSamvat?.gujarati}
              onBlur={handleBlur}
              placeholder="Swaminarayan Samvat Details"
            />
            {/* <Error field="swaminarayanSamvat.gujarati" /> */}
            {((formik.errors?.swaminarayanSamvat?.gujarati &&
              formik.touched?.swaminarayanSamvat?.gujarati) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.swaminarayanSamvat?.gujarati}
              </span>
            )}
          </div>

          <div className="form-group">
            <label>
              Swaminarayan Samvat Hindi
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="swaminarayanSamvat.hindi"
              onChange={handleChange}
              value={values?.swaminarayanSamvat?.hindi}
              onBlur={handleBlur}
              placeholder="Swaminarayan Samvat Details"
            />
            {/* <Error field="swaminarayanSamvat.hindi" /> */}
            {((formik.errors?.swaminarayanSamvat?.hindi &&
              formik.touched?.swaminarayanSamvat?.hindi) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.swaminarayanSamvat?.hindi}
              </span>
            )}
          </div>

          <div className="form-group">
            <label>
              Event Details English
            </label>
            <textarea
              className="form-control react-form-input"
              id="event.english"
              rows={3}
              onChange={handleChange}
              value={values?.event?.english}
              onBlur={handleBlur}
              placeholder="Event Details"
            />
            {/* <Error field="event.english" /> */}
            {((formik.errors?.event?.english &&
              formik.touched?.event?.english) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.event?.english}
              </span>
            )}
          </div>

          <div className="form-group">
            <label>
              Event Details Gujarati
            </label>
            <textarea
              className="form-control react-form-input"
              id="event.gujarati"
              rows={3}
              onChange={handleChange}
              value={values?.event?.gujarati}
              onBlur={handleBlur}
              placeholder="Event Details"
            />
            {((formik.errors?.event?.gujarati &&
              formik.touched?.event?.gujarati) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.event?.gujarati}
              </span>
            )}
            {/* <Error field="event.gujarati" /> */}
          </div>

          <div className="form-group">
            <label>
              Event Details Hindi
            </label>
            <textarea
              className="form-control react-form-input"
              id="event.hindi"
              rows={3}
              onChange={handleChange}
              value={values?.event?.hindi}
              onBlur={handleBlur}
              placeholder="Event Details"
            />
            {/* <Error field="event.hindi" /> */}
            {((formik.errors?.event?.hindi && formik.touched?.event?.hindi) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>{formik.errors?.event?.hindi}</span>
            )}
          </div>
          {/*  */}
          <div className="form-group">
            <label>
              Vachanamrut Tithi English
            </label>
            <textarea
              className="form-control react-form-input"
              id="vachanamrutTithi.english"
              rows={3}
              onChange={handleChange}
              value={values?.vachanamrutTithi?.english}
              onBlur={handleBlur}
              placeholder="Vachanamrut Tithi"
            />
            {/* <Error field="vachanamrutTithi.english" /> */}
            {((formik.errors?.vachanamrutTithi?.english &&
              formik.touched?.vachanamrutTithi?.english) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.vachanamrutTithi?.english}
              </span>
            )}
          </div>

          <div className="form-group">
            <label>
              Vachanamrut Tithi Gujarati
            </label>
            <textarea
              className="form-control react-form-input"
              id="vachanamrutTithi.gujarati"
              rows={3}
              onChange={handleChange}
              value={values?.vachanamrutTithi?.gujarati}
              onBlur={handleBlur}
              placeholder="Vachanamrut Tithi"
            />
            {((formik.errors?.vachanamrutTithi?.gujarati &&
              formik.touched?.vachanamrutTithi?.gujarati) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.vachanamrutTithi?.gujarati}
              </span>
            )}
            {/* <Error field="vachanamrutTithi.gujarati" /> */}
          </div>

          <div className="form-group">
            <label>
              Vachanamrut Tithi Hindi
            </label>
            <textarea
              className="form-control react-form-input"
              id="vachanamrutTithi.hindi"
              rows={3}
              onChange={handleChange}
              value={values?.vachanamrutTithi?.hindi}
              onBlur={handleBlur}
              placeholder="Vachanamrut Tithi"
            />
            {/* <Error field="vachanamrutTithi.hindi" /> */}
            {((formik.errors?.vachanamrutTithi?.hindi &&
              formik.touched?.vachanamrutTithi?.hindi) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.vachanamrutTithi?.hindi}
              </span>
            )}
          </div>

          {/*  */}
          <div className="form-group">
            <label>
              Date Vise Vachanamrut English
            </label>
            <textarea
              className="form-control react-form-input"
              id="dateViseVachanamrut.english"
              rows={3}
              onChange={handleChange}
              value={values?.dateViseVachanamrut?.english}
              onBlur={handleBlur}
              placeholder="Date Vise Vachanamrut"
            />
            {/* <Error field="dateViseVachanamrut.english" /> */}
            {((formik.errors?.dateViseVachanamrut?.english &&
              formik.touched?.dateViseVachanamrut?.english) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.dateViseVachanamrut?.english}
              </span>
            )}
          </div>

          <div className="form-group">
            <label>
              Date Vise Vachanamrut Gujarati
            </label>
            <textarea
              className="form-control react-form-input"
              id="dateViseVachanamrut.gujarati"
              rows={3}
              onChange={handleChange}
              value={values?.dateViseVachanamrut?.gujarati}
              onBlur={handleBlur}
              placeholder="Date Vise Vachanamrut"
            />
            {((formik.errors?.dateViseVachanamrut?.gujarati &&
              formik.touched?.dateViseVachanamrut?.gujarati) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.dateViseVachanamrut?.gujarati}
              </span>
            )}
            {/* <Error field="dateViseVachanamrut.gujarati" /> */}
          </div>

          <div className="form-group">
            <label>
              Date Vise Vachanamrut Hindi
            </label>
            <textarea
              className="form-control react-form-input"
              id="dateViseVachanamrut.hindi"
              rows={3}
              onChange={handleChange}
              value={values?.dateViseVachanamrut?.hindi}
              onBlur={handleBlur}
              placeholder="Date Vise Vachanamrut"
            />
            {/* <Error field="dateViseVachanamrut.hindi" /> */}
            {((formik.errors?.dateViseVachanamrut?.hindi &&
              formik.touched?.dateViseVachanamrut?.hindi) ||
              formik.submitCount > 0) && (
              <span className={"error-msg"}>
                {formik.errors?.dateViseVachanamrut?.hindi}
              </span>
            )}
          </div>

          <div className="row">
            <div className="col-5 offset-2 offset-sm-4 col-sm-4">
              <Button
                type="submit"
                className="btn form-button modaladdbutton"
                disabled={!formik.isValid || loading}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </div>
            <div className="col-5 col-sm-4">
              <Button
                onClick={onClose}
                className="btn form-button modalcancelbutton"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </ModalBody>
      {loading ? <Loader /> : ""}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
  };
};

export default compose(connect(mapStateToProps, { success, error }))(
  AddEditEvent
);
